import React from 'react';


function classDisplay(props){
return (
<div className="grid-item-class">
{props.cname}
</div>
);
}
export default classDisplay
